import { InvoicesService_invoiceDetailedSpecificationServiceGetGet } from '@festina/moneyin-general-types/moneyin/hooks/InvoicesService_invoiceDetailedSpecificationServiceGetGet'

export const useFetchInvoiceDetailedSpecification =
  InvoicesService_invoiceDetailedSpecificationServiceGetGet.useSuspenseQuery
